<template>
  <v-navigation-drawer
    ref="drawer"
    v-model="show"
    :width="navigation.width"
    color="#AAAAAACC"
    absolute
    hide-overlay
    stateless
    style="z-index: 2"
  >
    <!-- TOOLBAR -->
    <v-toolbar
      color="primaryLight"
      dark
      dense
    >
      <div
        class="toolbar-left"
        :class="{ 'toolbar-shifted': simCollapsed }"
      >
        <v-btn
          dark
          icon
          @click="exit(false)"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-divider
          class="mx-3"
          vertical
        />

        <v-toolbar-title>
          <template
            v-if="!isLoadingIncendio"
          >
            {{ incendio.NOMBRE ? incendio.NOMBRE : incendio.LOCALIDAD }}
          </template>

          <template
            v-else
          >
            <v-skeleton-loader
              type="heading"
              class="d-inline-block"
              :width="440"
              :height="28"
            />
          </template>
        </v-toolbar-title>
      </div>
      <v-spacer />

      <v-tooltip
        v-for="button in buttons"
        :key="button.id"
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            v-show="button.visible"
            v-bind="attrs"
            fab
            small
            class="me-3 fab-35"
            color="secondary"
            bottom
            right
            :disabled="isLoadingIncendio"
            v-on="on"
            @click="clickBtn(button.id)"
          >
            <v-icon
              color="primary"
            >
              {{ button.icon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ button.label }}</span>
      </v-tooltip>

      <!-- <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn fab small v-bind="attrs" v-on="on" v-show = "noEstaFinalizado" color="secondary" bottom right class="mr-3" @click="changeVisibilityNivelIncendio">
            <v-icon color="primary">mdi-list-status</v-icon>
          </v-btn>
        </template>
        <span>Cambiar</span>
      </v-tooltip> -->
    </v-toolbar>

    <v-container
      fluid
      style="height: calc(100vh - 112px); overflow-y: auto; padding: 0px"
    >
      <!-- SNACKBARS-->
      <v-snackbar
        v-model="showSnackBar"
        color="error"
        bottom
        :timeout="5000"
      >
        {{ msgSnackBar }}
      </v-snackbar>
      <v-snackbar
        v-model="isLoadingTrack"
        bottom
        :timeout="-1"
      >
        Descargando datos del track
        <template
          #action="{ attrs }"
        >
          <v-progress-circular
            indeterminate
            v-on="attrs"
          />
        </template>
      </v-snackbar>

      <!-- DIALOGS-->
      <vx-dialog-add-imagenes
        class="mt-4"
        :id-incendio="idIncendioSelected"
        :show="showDialogImagen"
        @cancelar="cancelAddImagenes"
      />
      <vx-dialog-track-fechas
        :show="showDialogTrackAllMedios"
        :id-incendio="idIncendioSelected"
        @aceptar="obtainAllTrackMedios"
        @cancelar="cancelTrackMedio"
      />

      <!-- COMPONENTS -->
      <v-container
        fluid
        class="toolbar-scope"
      >
        <!-- Datos Incendio -->
        <vx-datos-incendio
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
        />

        <!-- Datos Sectores -->
        <vx-datos-sectores
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
          @changeSectoresSelected="changeSectoresSelected"
        />

        <!-- Datos Medios -->
        <vx-datos-medios
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :sectores-selected="sectoresSelected"
          :loading="isLoadingIncendio"
        />

        <!-- Datos Gantt -->
        <vx-dialog-gantt
          v-if="idIncendioSelected"
          class="mt-4"
          :id-incendio="idIncendioSelected"
        />

        <!-- Datos Planes Operaciones -->
        <vx-datos-planes-operaciones
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
          @hideLeftMenu="exit(true)"
        />

        <!-- Datos Perímetros -->
        <vx-datos-perimetros
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
        />

        <vx-dialog-solicitud-medios
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :show="showDialogSolicitudMedios"
          @cancelar="cancelSolicitudMedios"
        />

        <!-- Datos Imágenes Satélite -->
        <vx-imagen-satelite
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
        />

        <!-- Datos Simulación -->
        <vx-simulacion
          v-if="idIncendioSelected"
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
          @closeDialog="exit"
        />

        <!-- Datos Alineaciones Campbell -->
        <vx-menu-alineaciones-campbell
          class="mt-4"
          :id-incendio="idIncendioSelected"
          :loading="isLoadingIncendio"
        />
      </v-container>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import DatosIncendio from './DatosIncendio'
import DatosPlanesOperaciones from './DatosPlanesOperaciones'
import DatosSectores from './DatosSectores'
import DatosMedios from './DatosMedios'
import constants from '@/helpers/constants'
import ImagenSatelite from './ImagenSatelite'
import DialogTrackAllMedios from './DialogTrackAllMedios'
import MenuAlineacionesCampbell from './MenuAlineacionesCampbell.vue'
import MenuPerimetro from './MenuPerimetro.vue'
import DialogAddImagenes from './DialogAddImagenes.vue'
import Simulacion from './Simulacion'
import DialogSolicitudMedios from './DialogAddPeticionesMedios.vue'

// import IncendioGestion from './IncendioGestion'

import * as ArcGIS from '@/helpers/ArcGIS'
import api from '@/api'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { mapGetters, mapActions } from 'vuex'
import DialogGantt from './DialogGantt.vue'

pdfMake.vfs = pdfFonts.vfs

export default {
  components: {
    'vx-datos-incendio': DatosIncendio,
    'vx-datos-planes-operaciones': DatosPlanesOperaciones,
    'vx-datos-sectores': DatosSectores,
    'vx-datos-perimetros': MenuPerimetro, // añadimos su componente
    'vx-datos-medios': DatosMedios,
    'vx-imagen-satelite': ImagenSatelite,
    'vx-dialog-track-fechas': DialogTrackAllMedios,
    'vx-menu-alineaciones-campbell': MenuAlineacionesCampbell,
    'vx-dialog-add-imagenes': DialogAddImagenes,
    'vx-simulacion': Simulacion,
    'vx-dialog-gantt': DialogGantt,
    'vx-dialog-solicitud-medios': DialogSolicitudMedios

    // 'vx-incendio-gestion': IncendioGestion,
  },

  props: {
    show: Boolean,
    showIncendiosCards: Boolean,
    idIncendioSelected: String,
    simCollapsed: Boolean
  },

  data: () => ({
    showDialogImagen: false,
    isLoadingTrack: false,
    msgSnackBar: '',
    showSnackBar: false,
    sectoresSelected: [],
    mediostracked: false,
    buttons: [
      {
        id: 'showTrack',
        icon: 'mdi-map-marker',
        label: 'Track de los medios asociados',
        visible: true
      },
      {
        id: 'hideTrack',
        icon: 'mdi-map-marker-off',
        label: 'Ocultar track',
        visible: false
      },
      {
        id: 'generatePDF',
        icon: 'mdi-file-pdf-box',
        label: 'Resumen del incendio',
        visible: true
      },
      {
        id: 'uploadImages',
        icon: 'mdi-camera',
        label: 'Subir imágenes',
        visible: true
      }
    ],
    dispositivosAllIncendios: new Map(),
    arrayDispositivosIncendio: [],
    showDialogTrackAllMedios: false,
    showDialogSolicitudMedios: false,

    navigation: {
      width: 650,
      borderSize: 3,
      minWidth: 650
    },

    isResizing: false,
    resizeRaf: null,
    resizeLastWidth: null
  }),

  computed: {
    ...mapGetters('incendio', ['getIncendioByID', 'isIncendioLoading']),
    incendio() {
      return this.getIncendioByID(this.idIncendioSelected)
    },
    deteccion() {
      const incendio = this.incendio
      return incendio ? this.$store.getters['incendio/getTipoDeteccionById'](incendio.ID_TIPO_DETECCION) : {}
    },
    medios() { return this.$store.getters['medio/medios'] },
    noEstaFinalizado() {
      const incendio = this.incendio
      return incendio ? (incendio.ESTADOS?.[0]?.TIPO_INCENDIO_ESTADO?.INCENDIO_ESTADO !== 'Finalizado') : true
    },
    isLoadingIncendio() {
      return !this.incendio
    }
  },

  watch: {
    async idIncendioSelected(id) {
      if (!id) return
      if (!this.getIncendioByID(id)) {
        await this.fetchIncendioById(id)
      }
      this.showSnackBar = false
      this.msgSnackBar = ''
      this.arrayDispositivosIncendio = this.dispositivosAllIncendios.get(id) || []
      this.visibilidadBotones()
    }
  },

  mounted() {
    this.setBorderWidth()
    this.setEvents()
  },

  methods: {
    ...mapActions('incendio', ['fetchIncendioById']),

    // Funciones auxiliares
    getFecha(id, medio) {
      switch (id) {
        case 0:
          return medio.FECHA_ALARMADO
        case 1:
          return medio.FECHA_EN_CAMINO
        case 2:
          return medio.FECHA_EN_LUGAR
        case 3:
          return medio.FECHA_FINALIZADO
        default:
          return null
      }
    },
    formatFechaFin(fechaFin) {
      if (fechaFin === null) return this.$date.now()
      return this.$date.parseDate(fechaFin)
    },
    formatFechaInicio(fechaInicio) {
      return this.$date.parseDate(fechaInicio)
    },

    visibilidadBotones() {
      const visibilidad = this.arrayDispositivosIncendio.length > 0

      this.buttons[0].visible = !visibilidad
      this.buttons[1].visible = visibilidad
    },

    clickBtn(btn) {
      if (btn === 'showTrack') {
        this.showDialogTrackAllMedios = true
      } else if (btn === 'hideTrack') {
        this.hideTrack()
      } else if (btn === 'generatePDF') {
        this.generatePDFIncendio()
      } else if (btn === 'uploadImages') {
        this.showDialogImagen = true
      }
    },
    changeSectoresSelected(sectoresSelected) {
      this.sectoresSelected = sectoresSelected
    },

    exit(showSymbology = false) {
      this.$el.scrollTop = 0
      this.$emit('exit', showSymbology)
    },

    // Funciones para localizar los medios
    async obtainAllTrackMedios(fechaInicio, fechaFin) {
      this.showDialogTrackAllMedios = false
      const idIncendio = this.incendio.ID_INCENDIO
      this.msgSnackBar = ''
      let tieneMedios = false

      this.isLoadingTrack = true
      for (let i = 0; i < this.incendio.SECTORES.length; i++) {
        for (let j = 0; j < this.incendio.SECTORES[i].MEDIOS.length; j++) {
          const medio = this.incendio.SECTORES[i].MEDIOS[j]
          tieneMedios = true
          await this.loadTrackFechas(medio, fechaInicio, fechaFin)
        }
      }
      this.isLoadingTrack = false

      if (this.arrayDispositivosIncendio) {
        this.dispositivosAllIncendios.set(
          idIncendio,
          this.arrayDispositivosIncendio
        )
      }

      // this.arrayDispositivosIncendio !== null ? this.dispositivosAllIncendios.set(idIncendio, this.arrayDispositivosIncendio) : {}
      if (!tieneMedios) {
        this.msgSnackBar = 'El incendio no tiene medios asociados.'
      }
      if (this.msgSnackBar.length !== 0) {
        this.showSnackBar = true
      }
      this.visibilidadBotones()
    },
    async loadTrackFechas(medio, fechaInicio, fechaFin) {
      const infoMedio = this.medios.find((x) => x.ID_MEDIO === medio.ID_MEDIO)

      // Si la fecha de inicio no es nula
      if (this.getFecha(fechaInicio, medio) !== null) {
        // let fechaInit = this.formatFechaInicio(this.getFecha(fechaInicio, medio))
        // let fechaEnd = this.formatFechaFin(this.getFecha(fechaFin, medio))

        const dateInit = this.getFecha(fechaInicio, medio)
          ? new Date(this.getFecha(fechaInicio, medio)).toISOString()
          : new Date().toISOString()
        const dateEnd = this.getFecha(fechaFin, medio)
          ? new Date(this.getFecha(fechaFin, medio)).toISOString()
          : new Date().toISOString()
        // Date format: 2023-03-17T11:13:00.000Z
        try {
          const idDispositivo = await api.medio.getIdDispositivo(medio.ID_MEDIO)

          if (idDispositivo.data === null) {
            this.msgSnackBar +=
                `El medio ${infoMedio.MEDIO} no dispone de track.\n`
          } else {
            const response = await api.medio.getTrackFechasMedio(
              idDispositivo.data.ID_GEO_DISPOSITIVO,
              dateInit,
              dateEnd
            )
            if (response.status === 200) {
              if (response.data.length >= 2) {
                this.showTrack(response.data)
              }
            }

            if (response.status === 204) {
              this.msgSnackBar +=
                  `El medio ${infoMedio.MEDIO} no dispone de track.\n`
            }
          }
        } catch (err) {
          this.$log.error(
            `Error al obtener el track${infoMedio.ID_MEDIO}`,
            err
          )
          this.msgSnackBar +=
            `Error al obtener el track del dispositivo del medio ${
            infoMedio.MEDIO
            }\n`
        }
      } else {
        this.msgSnackBar +=
          `Fecha de inicio invalida del medio ${infoMedio.MEDIO}\n`
      }
    },
    // Funcion para cancelar el trackeo en el dialog
    cancelTrackMedio() {
      this.showDialogTrackAllMedios = false
    },
    showTrack(posiciones) {
      const maxTimeDiference = constants.track.timeDiferenceTrackMinutes
      const maxPositions = constants.track.maxPositions
      const positions = []
      let nameTrack = ''

      for (let i = 0; i < posiciones.length; i++) {
        if (nameTrack === '' && posiciones[i].MEDIO) {
          nameTrack = posiciones[i].MEDIO
        }
        if (i === 0 || i === posiciones.length - 1) {
          positions.push(posiciones[i])
        } else {
          const dateLastPos = this.$date.parseDate(posiciones[i - 1].FECHA)
          const date = this.$date.parseDate(posiciones[i].FECHA)
          const difMinutes = dateLastPos.diff(date, 'minutes')

          if (difMinutes <= maxTimeDiference && positions.length <= maxPositions) {
            // this.track.positions.push(posiciones[i])
            positions.push(posiciones[i])
          } else {
            continue
          }
        }
      }
      /**
       * Distinguir entre dispositivo o medio
       */
      const idTrack = '' //

      ArcGIS.drawTrack(idTrack, nameTrack, positions, true)
      this.arrayDispositivosIncendio.push(idTrack)
    },
    // Ocultar los tracks
    hideTrack() {
      const idIncendio = this.incendio.ID_INCENDIO
      const dispositivosEliminar = this.dispositivosAllIncendios.get(idIncendio)
      for (let i = 0; i <= dispositivosEliminar.length; i++) {
        const dispositivo = dispositivosEliminar.pop()
        ArcGIS.hideTrack(dispositivo)
      }
      this.visibilidadBotones()
      this.dispositivosAllIncendios.delete(idIncendio)
    },

    generatePDFIncendio() {
      let tieneMedios = false
      const tableEstados = []
      const tableMedios = []
      const listaMedios = []

      // Creo la tabla de estados
      const estados = this.incendio.ESTADOS
      for (let i = 0; i < estados.length; i++) {
        const estado = []
        estado.push(
          this.$date.formatDate(estados[i].FECHA, 'DD/MM/YYYY HH:mm')
        )
        estado.push(estados[i].TIPO_INCENDIO_ESTADO.INCENDIO_ESTADO)
        tableEstados.unshift(estado)
      }

      tableEstados.unshift(['Fecha', 'Estado'])
      tableMedios.push([
        'Medio',
        'Categoría',
        'Alarmado',
        'En Camino',
        'En Lugar',
        'Finalizado',
        'Horas',
        'Total'
      ])

      // Ordeno la lista de medios por fecha
      for (let i = 0; i < this.incendio.SECTORES.length; i++) {
        for (let j = 0; j < this.incendio.SECTORES[i].MEDIOS.length; j++) {
          tieneMedios = true
          listaMedios.push(this.incendio.SECTORES[i].MEDIOS[j])
        }
      }

      listaMedios.sort((a, b) => {
        const aAviso = a.FECHA_ALARMADO
        const bAviso = b.FECHA_ALARMADO
        const aLlegada = a.FECHA_EN_CAMINO
        const bLlegada = b.FECHA_EN_CAMINO
        const aSalida = a.FECHA_EN_LUGAR
        const bSalida = b.FECHA_EN_LUGAR
        const aBase = a.FECHA_FINALIZADO
        const bBase = b.FECHA_FINALIZADO

        if (aAviso === bAviso) {
          if (aSalida === bSalida) {
            if (aBase === bBase) {
              return aBase < bBase ? -1 : aBase > bBase ? 1 : 0
            } else {
              return aSalida < bSalida ? -1 : aSalida > bSalida ? 1 : 0
            }
          } else {
            return aLlegada < bLlegada ? -1 : aLlegada > bLlegada ? 1 : 0
          }
        } else {
          return aAviso < bAviso ? -1 : 1
        }
      })

      const medioTotalList = []
      for (let i = 0; i < listaMedios.length; i++) {
        const medio = listaMedios[i]
        let horaMedio = 0
        const findMedio = this.medios.find((x) => x.ID_MEDIO === medio.ID_MEDIO)

        if (medio.FECHA_ALARMADO && medio.FECHA_FINALIZADO) {
          let diff = 0
          const fechaInicio = new Date(medio.FECHA_ALARMADO).getTime()
          const fechaFin = new Date(medio.FECHA_FINALIZADO).getTime()
          diff = fechaFin - fechaInicio
          horaMedio = diff / (1000 * 60 * 60)
        }

        const medioTotalIndex = medioTotalList.findIndex(
          (x) => x.MEDIO === findMedio.MEDIO
        )
        if (medioTotalIndex > -1) {
          medioTotalList[medioTotalIndex].TOTAL =
            medioTotalList[medioTotalIndex].TOTAL + horaMedio
        } else {
          medioTotalList.push({ MEDIO: findMedio.MEDIO, TOTAL: horaMedio })
        }
      }

      // Creo la tabla de medios

      for (let i = 0; i < listaMedios.length; i++) {
        const medioTable = []
        const medio = listaMedios[i]
        const findMedio = this.medios.find((x) => x.ID_MEDIO === medio.ID_MEDIO)

        medioTable.push(findMedio.MEDIO)
        medioTable.push(findMedio.CATEGORIA)
        medioTable.push(
          this.$date.formatDate(medio.FECHA_ALARMADO, 'DD/MM/YYYY HH:mm')
        )
        medioTable.push(
          this.$date.formatDate(medio.FECHA_EN_CAMINO, 'DD/MM/YYYY HH:mm')
        )
        medioTable.push(
          this.$date.formatDate(medio.FECHA_EN_LUGAR, 'DD/MM/YYYY HH:mm')
        )
        medioTable.push(
          this.$date.formatDate(medio.FECHA_FINALIZADO, 'DD/MM/YYYY HH:mm')
        )

        // Calculo las horas de actuacion si el ciclo esta cerrado
        let horaMedio2 = 0
        if (medio.FECHA_ALARMADO && medio.FECHA_FINALIZADO) {
          let diff2 = 0
          const fechaInicio2 = new Date(medio.FECHA_ALARMADO).getTime()
          const fechaFin2 = new Date(medio.FECHA_FINALIZADO).getTime()
          diff2 = fechaFin2 - fechaInicio2
          horaMedio2 = diff2 / (1000 * 60 * 60)
        }
        // console.log(diff / (1000 * 60 * 60))

        // let totalMedio = 0
        medioTable.push(horaMedio2.toFixed(2))
        medioTable.push(
          medioTotalList
            .find((x) => x.MEDIO === findMedio.MEDIO)
            .TOTAL.toFixed(2)
        )

        tableMedios.push(medioTable)
      }

      const docDefinition = {
        // pageOrientation: 'landscape',
        content: [],
        defaultStyle: {
          fontSize: 11
        }
      }

      docDefinition.content.push(constants.headerPDF)
      docDefinition.content.push(
        {
          text: [
            { text: 'Fecha/hora informe: ', bold: true },
            this.$date.currentDate()
          ],
          margin: [0, 0, 0, 15]
        },
        {
          text: [
            {
              text: 'Datos del incendio',
              bold: true,
              fontSize: 15,
              alignment: 'center'
            }
          ],
          margin: [0, 0, 0, 15]
        },
        {
          ul: [
            {
              text: [
                { text: 'Localidad: ', bold: true },
                this.incendio.LOCALIDAD
              ]
            },
            {
              text: [
                { text: 'Coordenadas: ', bold: true },
                `${this.incendio.LATITUD}, ${this.incendio.LONGITUD}`
              ]
            },
            {
              text: [
                { text: 'Detección: ', bold: true },
                this.deteccion.DETECCION
              ]
            },
            {
              text: [
                { text: 'Observaciones: ', bold: true },
                this.incendio.OBSERVACIONES
              ]
            }
          ]
        },
        /* {
            columns: [
              { width: '*', text: '' },
              {
                width: 'auto',
                table: {
                  body: tableEstados
                }
              },
              { width: '*', text: '' }
            ]
          }, */
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            widths: [120, 120],
            headerRows: 1,
            body: tableEstados
          },
          margin: [120, 20, 75, 20],
          alignment: 'center'
        },
        {
          text: [
            { text: 'Medios', bold: true, fontSize: 15, alignment: 'center' }
          ],
          margin: [0, 0, 0, 15]
        } /*,
          {
            layout: 'lightHorizontalLines', // optional
            table: {
              headerRows: 1,
              body: tableMedios
            },
            margin: [0, 15, 0, 20],
            alignment: 'center',
            width: '100%'
          } */
      )

      if (tieneMedios) {
        docDefinition.content.push({
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            body: tableMedios
          },
          margin: [0, 15, 0, 20],
          alignment: 'center',
          width: '*'
        })
      } else {
        docDefinition.content.push({
          text: [
            { text: 'No existen medios', bold: false, alignment: 'center' }
          ],
          margin: [0, 0, 0, 15]
        })
      }
      pdfMake
        .createPdf(docDefinition)
        .download(
          `Incendio_${
            this.incendio.LOCALIDAD
            }_${
            this.$date.now().format('YYYY_MM_DD_hh_mm')}`
        )
    },

    cancelSolicitudMedios() {
      this.showDialogSolicitudMedios = false
    },

    cancelAddImagenes() {
      this.showDialogImagen = false
    },

    setBorderWidth() {
      const i = this.$refs.drawer.$el.querySelector(
        '.v-navigation-drawer__border'
      )
      i.style.width = `${this.navigation.borderSize}px`
      i.style.cursor = 'ew-resize'
      i.style.backgroundColor = 'transparent'
    },
    setEvents() {
      const el = this.$refs.drawer.$el
      const border = el.querySelector('.v-navigation-drawer__border')
      const dir = el.classList.contains('v-navigation-drawer--right') ? 'right' : 'left'
      const minW = this.navigation.minWidth

      const onMove = e => {
        if (!this.isResizing) return
        const vw = window.innerWidth
        const w = dir === 'right' ? (vw - e.clientX) : e.clientX
        this.resizeLastWidth = Math.max(minW, Math.min(vw, w))
        if (this.resizeRaf) return
        this.resizeRaf = requestAnimationFrame(() => {
          this.navigation.width = `${this.resizeLastWidth}px`
          this.resizeRaf = 0
        })
      }

      const onUp = () => {
        if (!this.isResizing) return
        this.isResizing = false
        document.removeEventListener('mousemove', onMove, false)
        document.removeEventListener('mouseup', onUp, false)
        document.body.style.userSelect = ''
        document.body.style.cursor = ''
      }

      const onDown = e => {
        if (e.offsetX > this.navigation.borderSize) return
        e.preventDefault()
        this.isResizing = true
        document.addEventListener('mousemove', onMove, false)
        document.addEventListener('mouseup', onUp, false)
        document.body.style.userSelect = 'none'
        document.body.style.cursor = 'ew-resize'
      }

      border.addEventListener('mousedown', onDown, false)
    }
  }
}
</script>

<style scoped>
.toolbar-left {
  display: flex;
  align-items: center;
  transition: margin-left 0.3s ease;
}

.toolbar-shifted {
  margin-left: 50px;
}

.fab-35.v-btn.v-btn--fab {
  width: 35px;
  height: 35px;
  min-width: 35px;
  padding: 0;
  line-height: 35px;
}
/* Botones de componentes internos en toolbars */
.toolbar-scope ::v-deep .v-toolbar .v-btn.v-btn--fab {
  width: 35px;
  height: 35px;
  min-width: 35px;
  padding: 0;
  line-height: 35px;
}
</style>
